import { Controller } from "@hotwired/stimulus";
import { get } from "@rails/request.js";

// "Attendance For" day/occurrence filter. On change it live-updates the
// performance hub (turbo-stream replace of #attendance_hub_content) and reloads
// the attendees datatable for the selected occurrence — no page reload.
export default class extends Controller {
  static targets = ["select", "showing"];
  static values = { hubUrl: String, count: Number };

  async change() {
    const date = this.selectTarget.value;

    // 1) Refresh the hub metrics (tiles + progress + ticket-type breakdown).
    const url = new URL(this.hubUrlValue, window.location.origin);
    if (date) url.searchParams.set("subevent_date", date);
    await get(url.toString(), { responseKind: "turbo-stream" });

    // 2) Point the attendees datatable at this occurrence and reload it.
    const tableEl = document.getElementById("attendee_listing_wrapper");
    if (tableEl) {
      const ctrl = this.application.getControllerForElementAndIdentifier(tableEl, "attendee-datatable");
      if (ctrl) {
        ctrl.subeventDateValue = date || "";
        if (ctrl.dataTable) ctrl.dataTable.ajax.reload();
      }
    }

    // 3) Update the "Showing:" pill.
    if (this.hasShowingTarget) {
      const opt = this.selectTarget.options[this.selectTarget.selectedIndex];
      this.showingTarget.firstChild &&
        (this.showingTarget.childNodes[0].nodeValue =
          date ? `${this.showingLabel("one", opt.text)} ` : `${this.showingLabel("all")} `);
    }
  }

  showingLabel(mode, date) {
    // Mirror the server i18n strings; kept simple to avoid a JSON round-trip.
    if (mode === "one") return `Showing: ${date}`;
    return `Showing: All Occurrences (${this.countValue} total)`;
  }
}
